import { render, staticRenderFns } from "./BotaoGerarPdfHistorico.vue?vue&type=template&id=33d36cd6"
import script from "./BotaoGerarPdfHistorico.vue?vue&type=script&lang=js"
export * from "./BotaoGerarPdfHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports